"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Stack_1 = require("../../components/Stack");
var Text_1 = require("../../components/Text");
var TitleBox = function (_a) {
  var title = _a.title,
    caption = _a.caption;
  if (!title && !caption) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
  }
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    style: {
      padding: "8px 10px"
    }
  }, {
    children: [title && (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      size: 16,
      weight: "medium"
    }, {
      children: title
    })), caption && (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      size: 13,
      style: {
        color: "#757575"
      }
    }, {
      children: caption
    }))]
  }));
};
exports.TitleBox = TitleBox;